import React from 'react'

import {SubscriptionQuoteButton} from '@/app/modules/purchases/SubscriptionQuoteButton'
import {useSubscription} from '@/shared/utils/SubscriptionProvider'

/**
 * Read-only notice inside the composer card for an expired subscription that licensed ENGINE: the
 * chat and its history stay browsable, only new turns are blocked. Takes precedence over the
 * cloud-units banner (which renders nothing without full chat access).
 */
export const ComposerSubscriptionBanner: React.FC = () => {
  const {canUseAiChat, canViewAiChat} = useSubscription()

  if (canUseAiChat || !canViewAiChat) {
    return null
  }

  // Same visual as the cloud-units "empty" lock, so both paused states read alike.
  return (
    <div
      className='aui-cloud-units-banner aui-cloud-units-banner--empty'
      role='alert'
      data-testid='omics-ai-chat-subscription-banner'
    >
      <i className='fas fa-calendar-xmark' aria-hidden />
      <span className='aui-cloud-units-banner__text'>
        Your subscription has expired — your conversations are read-only.
      </span>
      <SubscriptionQuoteButton
        kind='renew'
        label='Renew'
        className='aui-cloud-units-banner__action'
      />
    </div>
  )
}
